import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import {
  EtsyBulkCreateGdriveFolderItemInput,
  MutationCreateQueueJobArgs,
  QueueJob,
  QueueJobInput,
} from '../__generated__/resolvers-types';

export const SET_ETSY_BULK_CREATE_GDRIVE_FOLDER_MUTATION = gql`
  mutation CreateQueueJob($job: QueueJobInput!) {
    createQueueJob(job: $job) {
      id
      status
      expireTimestamp
      creationTimestamp
      lastUpdateTimestamp
      etsyBulkCreateGdriveFolder {
        shopRecordId
        template
        gdriveUrl
        imageFolder
        productFolder
        items {
          id
          name
          status
          error
        }
      }
    }
  }
`;

/**
 * bulk upload etsy product where each folder is a product
 * @returns
 */
export default function useSetEtsyBulkCreateGdriveFolder() {
  const [createBulkEtsyCreateGdriveFolderJob, {data, loading, error}] = useMutation<
    QueueJob,
    MutationCreateQueueJobArgs
  >(SET_ETSY_BULK_CREATE_GDRIVE_FOLDER_MUTATION);

  return {
    createBulkEtsyCreateGdriveFolderJob: (
      shopRecordId: string,
      url: string,
      template: string,
      imageFolder: string,
      productFolder: string,
      items: EtsyBulkCreateGdriveFolderItemInput[],
    ) => {
      const job: QueueJobInput = {
        etsyBulkCreateGdriveFolder: {
          shopRecordId,
          gdriveUrl: url,
          template,
          imageFolder,
          productFolder,
          items,
        },
      };
      return createBulkEtsyCreateGdriveFolderJob({
        variables: {job},
      });
    },
    data,
    loading,
    error,
  };
}
